/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NumberOfCips } from './numberOfCips';


export interface StatusCodeValueNumberOfCips { 
    value?: NumberOfCips;
    status_code?: number;
}

